export type USER_SETTINGS_HAS_ERRORED = typeof USER_SETTINGS_HAS_ERRORED
export const USER_SETTINGS_HAS_ERRORED = '[User Settings] USER_SETTINGS_HAS_ERRORED'

/* Employees */
export const SET_PASSWORD = '[User Settings] SET_PASSWORD'
export type SET_PASSWORD = typeof SET_PASSWORD

export const SET_PASSWORD_SUCCESS = '[User Settings] SET_PASSWORD_SUCCESS'
export type SET_PASSWORD_SUCCESS = typeof SET_PASSWORD_SUCCESS

export const GET_TOTP_CONF = '[User Settings] GET_TOTP_CONF'
export type GET_TOTP_CONF = typeof GET_TOTP_CONF

export const GET_TOTP_CONF_SUCCESS = '[User Settings] GET_TOTP_CONF_SUCCESS'
export type GET_TOT_CONF_SUCCESS = typeof GET_TOTP_CONF_SUCCESS

export type SET_EMPLOYEE_ACTIVE_PAGE = typeof SET_EMPLOYEE_ACTIVE_PAGE
export const SET_EMPLOYEE_ACTIVE_PAGE = '[User Settings] SET_EMPLOYEE_ACTIVE_PAGE'

export const SET_EMAIL_NOTIFICATIONS = '[User Settings] SET_EMAIL_NOTIFICATIONS';
export type SET_EMAIL_NOTIFICATIONS = typeof SET_EMAIL_NOTIFICATIONS;

export const SET_EMAIL_NOTIFICATIONS_SUCCESS = '[User Settings] SET_EMAIL_NOTIFICATIONS_SUCCESS';
export type SET_EMAIL_NOTIFICATIONS_SUCCESS = typeof SET_EMAIL_NOTIFICATIONS_SUCCESS;

export type EMPLOYEES_HAS_ERRORED = typeof EMPLOYEES_HAS_ERRORED
export const EMPLOYEES_HAS_ERRORED = '[User Settings] EMPLOYEES_HAS_ERRORED'

export type GET_EMPLOYEES = typeof GET_EMPLOYEES
export const GET_EMPLOYEES = '[User Settings] GET_EMPLOYEES'

export const GET_EMPLOYEES_SUCCESS = '[User Settings] GET_EMPLOYEES_SUCCESS'
export type GET_EMPLOYEES_SUCCESS = typeof GET_EMPLOYEES_SUCCESS

export type GET_PAGINATED_EMPLOYEES = typeof GET_PAGINATED_EMPLOYEES
export const GET_PAGINATED_EMPLOYEES = '[User Settings] GET_PAGINATED_EMPLOYEES'

export const GET_PAGINATED_EMPLOYEES_SUCCESS = '[User Settings] GET_PAGINATED_EMPLOYEES_SUCCESS'
export type GET_PAGINATED_EMPLOYEES_SUCCESS = typeof GET_PAGINATED_EMPLOYEES_SUCCESS

export type CREATE_EMPLOYEE = typeof CREATE_EMPLOYEE
export const CREATE_EMPLOYEE = '[User Settings] CREATE_EMPLOYEE'

export const CREATE_EMPLOYEE_SUCCESS = '[User Settings] CREATE_EMPLOYEE_SUCCESS'
export type CREATE_EMPLOYEE_SUCCESS = typeof CREATE_EMPLOYEE_SUCCESS

export type UPDATE_EMPLOYEE = typeof UPDATE_EMPLOYEE
export const UPDATE_EMPLOYEE = '[User Settings] UPDATE_EMPLOYEE'

export const UPDATE_EMPLOYEE_SUCCESS = '[User Settings] UPDATE_EMPLOYEE_SUCCESS'
export type UPDATE_EMPLOYEE_SUCCESS = typeof UPDATE_EMPLOYEE_SUCCESS

export type UPDATE_EMPLOYEE_PHOTO = typeof UPDATE_EMPLOYEE_PHOTO
export const UPDATE_EMPLOYEE_PHOTO = '[User Settings] UPDATE_EMPLOYEE_PHOTO'

export const UPDATE_EMPLOYEE_PHOTO_SUCCESS = '[User Settings] UPDATE_EMPLOYEE_PHOTO_SUCCESS'
export type UPDATE_EMPLOYEE_PHOTO_SUCCESS = typeof UPDATE_EMPLOYEE_PHOTO_SUCCESS

export type REMOVE_EMPLOYEE_PHOTO = typeof REMOVE_EMPLOYEE_PHOTO
export const REMOVE_EMPLOYEE_PHOTO = '[User Settings] REMOVE_EMPLOYEE_PHOTO'

export const REMOVE_EMPLOYEE_PHOTO_SUCCESS = '[User Settings] REMOVE_EMPLOYEE_PHOTO_SUCCESS'
export type REMOVE_EMPLOYEE_PHOTO_SUCCESS= typeof REMOVE_EMPLOYEE_PHOTO_SUCCESS

export type DELETE_EMPLOYEE = typeof DELETE_EMPLOYEE
export const DELETE_EMPLOYEE = '[User Settings] DELETE_EMPLOYEE'

export const DELETE_EMPLOYEE_SUCCESS = '[User Settings] DELETE_EMPLOYEE_SUCCESS'
export type DELETE_EMPLOYEE_SUCCESS = typeof DELETE_EMPLOYEE_SUCCESS

export const SORT_EMPLOYEES = '[User Settings] SORT_EMPLOYEES'
export type SORT_EMPLOYEES = typeof SORT_EMPLOYEES

export const FILTER_EMPLOYEES = '[User Settings] FILTER_EMPLOYEES'
export type FILTER_EMPLOYEES = typeof FILTER_EMPLOYEES

export const SELECT_EMPLOYEE = '[User Settings] SELECT_EMPLOYEE'
export type SELECT_EMPLOYEE = typeof SELECT_EMPLOYEE

export const OPEN_EMPLOYEE_FORM = '[User Settings] OPEN_EMPLOYEE_FORM'
export type OPEN_EMPLOYEE_FORM = typeof OPEN_EMPLOYEE_FORM

export type SET_EMPLOYEES_POSITIONS = typeof SET_EMPLOYEES_POSITIONS
export const SET_EMPLOYEES_POSITIONS = '[User Settings] SET_EMPLOYEES_POSITIONS'

export const SET_EMPLOYEES_POSITIONS_SUCCESS = '[User Settings] SET_EMPLOYEES_POSITIONS_SUCCESS'
export type SET_EMPLOYEES_POSITIONS_SUCCESS = typeof SET_EMPLOYEES_POSITIONS_SUCCESS

export type GET_EMPLOYEE = typeof GET_EMPLOYEE
export const GET_EMPLOYEE = '[User Settings] GET_EMPLOYEE'

export type GET_EMPLOYEE_SUCCESS = typeof GET_EMPLOYEE_SUCCESS
export const GET_EMPLOYEE_SUCCESS = '[User Settings] GET_EMPLOYEE_SUCCESS'

export type GET_EMPLOYEES_OPEN_PROJECT = typeof GET_EMPLOYEES_OPEN_PROJECT
export const GET_EMPLOYEES_OPEN_PROJECT = '[User Settings] GET_EMPLOYEES_OPEN_PROJECT'

export type GET_EMPLOYEES_OPEN_PROJECT_SUCCESS = typeof GET_EMPLOYEES_OPEN_PROJECT_SUCCESS
export const GET_EMPLOYEES_OPEN_PROJECT_SUCCESS = '[User Settings] GET_EMPLOYEES_OPEN_PROJECT_SUCCESS'

export type GET_PAGINATED_EMPLOYEES_OPEN_PROJECT = typeof GET_PAGINATED_EMPLOYEES_OPEN_PROJECT
export const GET_PAGINATED_EMPLOYEES_OPEN_PROJECT = '[User Settings] GET_PAGINATED_EMPLOYEES_OPEN_PROJECT'

export type GET_PAGINATED_EMPLOYEES_OPEN_PROJECT_SUCCESS = typeof GET_PAGINATED_EMPLOYEES_OPEN_PROJECT_SUCCESS
export const GET_PAGINATED_EMPLOYEES_OPEN_PROJECT_SUCCESS = '[User Settings] GET_PAGINATED_EMPLOYEES_OPEN_PROJECT_SUCCESS'

export const SET_PAGINATED_EMPLOYEES_OPEN_PROJECT_ACTIVE_PAGE = '[User Settings] SET_PAGINATED_EMPLOYEES_OPEN_PROJECT_ACTIVE_PAGE'
export type SET_PAGINATED_EMPLOYEES_OPEN_PROJECT_ACTIVE_PAGE = typeof SET_PAGINATED_EMPLOYEES_OPEN_PROJECT_ACTIVE_PAGE

export type GET_INVOLVEMENT_EMPLOYEES = typeof GET_INVOLVEMENT_EMPLOYEES
export const GET_INVOLVEMENT_EMPLOYEES = '[User Settings] GET_INVOLVEMENT_EMPLOYEES'

export type GET_INVOLVEMENT_EMPLOYEES_SUCCESS = typeof GET_INVOLVEMENT_EMPLOYEES_SUCCESS
export const GET_INVOLVEMENT_EMPLOYEES_SUCCESS = '[User Settings] GET_INVOLVEMENT_EMPLOYEES_SUCCESS'

export type GET_PAGINATED_INVOLVEMENT_EMPLOYEES = typeof GET_PAGINATED_INVOLVEMENT_EMPLOYEES
export const GET_PAGINATED_INVOLVEMENT_EMPLOYEES = '[User Settings] GET_PAGINATED_INVOLVEMENT_EMPLOYEES'

export type GET_PAGINATED_INVOLVEMENT_EMPLOYEES_SUCCESS = typeof GET_PAGINATED_INVOLVEMENT_EMPLOYEES_SUCCESS
export const GET_PAGINATED_INVOLVEMENT_EMPLOYEES_SUCCESS = '[User Settings] GET_PAGINATED_INVOLVEMENT_EMPLOYEES_SUCCESS'

export const SET_PAGINATED_INVOLVEMENT_EMPLOYEES_ACTIVE_PAGE = '[User Settings] SET_PAGINATED_INVOLVEMENT_EMPLOYEES_ACTIVE_PAGE'
export type SET_PAGINATED_INVOLVEMENT_EMPLOYEES_ACTIVE_PAGE = typeof SET_PAGINATED_INVOLVEMENT_EMPLOYEES_ACTIVE_PAGE

/* Departments */
export type GET_DEPARTMENTS = typeof GET_DEPARTMENTS
export const GET_DEPARTMENTS = '[User Settings] GET_DEPARTMENTS'

export const GET_DEPARTMENTS_SUCCESS = '[User Settings] GET_DEPARTMENTS_SUCCESS'
export type GET_DEPARTMENTS_SUCCESS = typeof GET_DEPARTMENTS_SUCCESS

export type GET_PAGINATED_DEPARTMENTS = typeof GET_PAGINATED_DEPARTMENTS
export const GET_PAGINATED_DEPARTMENTS = '[User Settings] GET_PAGINATED_DEPARTMENTS'

export const GET_PAGINATED_DEPARTMENTS_SUCCESS = '[User Settings] GET_PAGINATED_DEPARTMENTS_SUCCESS'
export type GET_PAGINATED_DEPARTMENTS_SUCCESS = typeof GET_PAGINATED_DEPARTMENTS_SUCCESS

export type GET_DEPARTMENT = typeof GET_DEPARTMENT
export const GET_DEPARTMENT = '[User Settings] GET_DEPARTMENT'

export const GET_DEPARTMENT_SUCCESS = '[User Settings] GET_DEPARTMENT_SUCCESS'
export type GET_DEPARTMENT_SUCCESS = typeof GET_DEPARTMENT_SUCCESS

export type CREATE_DEPARTMENT = typeof CREATE_DEPARTMENT
export const CREATE_DEPARTMENT = '[User Settings] CREATE_DEPARTMENT'

export const CREATE_DEPARTMENT_SUCCESS = '[User Settings] CREATE_DEPARTMENT_SUCCESS'
export type CREATE_DEPARTMENT_SUCCESS = typeof CREATE_DEPARTMENT_SUCCESS

export type UPDATE_DEPARTMENT = typeof UPDATE_DEPARTMENT
export const UPDATE_DEPARTMENT = '[User Settings] UPDATE_DEPARTMENT'

export const UPDATE_DEPARTMENT_SUCCESS = '[User Settings] UPDATE_DEPARTMENT_SUCCESS'
export type UPDATE_DEPARTMENT_SUCCESS = typeof UPDATE_DEPARTMENT_SUCCESS

export type DELETE_DEPARTMENT = typeof DELETE_DEPARTMENT
export const DELETE_DEPARTMENT = '[User Settings] DELETE_DEPARTMENT'

export const DELETE_DEPARTMENT_SUCCESS = '[User Settings] DELETE_DEPARTMENT_SUCCESS'
export type DELETE_DEPARTMENT_SUCCESS = typeof DELETE_DEPARTMENT_SUCCESS

export const SORT_DEPARTMENTS = '[User Settings] SORT_DEPARTMENTS'
export type SORT_DEPARTMENTS = typeof SORT_DEPARTMENTS

export type ADD_EMPLOYEES_TO_DEPARTMENT = typeof ADD_EMPLOYEES_TO_DEPARTMENT
export const ADD_EMPLOYEES_TO_DEPARTMENT = '[User Settings] ADD_EMPLOYEES_TO_DEPARTMENT'

export type SELECTED_DEPARTMENT = typeof SELECTED_DEPARTMENT
export const SELECTED_DEPARTMENT = '[User Settings] SELECTED_DEPARTMENT'

export const OPEN_DEPARTMENT_FORM = '[User Settings] OPEN_DEPARTMENT_FORM'
export type OPEN_DEPARTMENT_FORM = typeof OPEN_DEPARTMENT_FORM

export type SET_DEPARTMENT_ACTIVE_PAGE = typeof SET_DEPARTMENT_ACTIVE_PAGE
export const SET_DEPARTMENT_ACTIVE_PAGE = '[User Settings] SET_DEPARTMENT_ACTIVE_PAGE'

export const FILTER_DEPARTMENTS = '[User Settings] FILTER_DEPARTMENTS'
export type FILTER_DEPARTMENTS = typeof FILTER_DEPARTMENTS

/* General Form Company */
export type COMPANY_HAS_ERRORED = typeof COMPANY_HAS_ERRORED
export const COMPANY_HAS_ERRORED = '[User Settings] COMPANY_HAS_ERRORED'

export type GET_COMPANIES = typeof GET_COMPANIES
export const GET_COMPANIES = '[User Settings] GET_COMPANIES'

export type GET_COMPANIES_SUCCESS = typeof GET_COMPANIES_SUCCESS
export const GET_COMPANIES_SUCCESS = '[User Settings] GET_COMPANIES_SUCCESS'

export type GET_COMPANY = typeof GET_COMPANY
export const GET_COMPANY = '[User Settings] GET_COMPANY'

export const GET_COMPANY_SUCCESS = '[User Settings] GET_COMPANY_SUCCESS'
export type GET_COMPANY_SUCCESS = typeof GET_COMPANY_SUCCESS

export type CREATE_COMPANY = typeof CREATE_COMPANY
export const CREATE_COMPANY = '[User Settings] CREATE_COMPANY'

export const CREATE_COMPANY_SUCCESS = '[User Settings] CREATE_COMPANY_SUCCESS'
export type CREATE_COMPANY_SUCCESS = typeof CREATE_COMPANY_SUCCESS

export type UPDATE_COMPANY = typeof UPDATE_COMPANY
export const UPDATE_COMPANY = '[User Settings] UPDATE_COMPANY'

export const UPDATE_COMPANY_SUCCESS = '[User Settings] UPDATE_COMPANY_SUCCESS'
export type UPDATE_COMPANY_SUCCESS = typeof UPDATE_COMPANY_SUCCESS

/* General Form Standard Setting */
export type STANDARD_SETTING_HAS_ERRORED = typeof STANDARD_SETTING_HAS_ERRORED
export const STANDARD_SETTING_HAS_ERRORED = '[User Settings] STANDARD_SETTING_HAS_ERRORED'

export type GET_STANDARD_SETTINGS = typeof GET_STANDARD_SETTINGS
export const GET_STANDARD_SETTINGS = '[User Settings] GET_STANDARD_SETTINGS'

export type GET_STANDARD_SETTINGS_SUCCESS = typeof GET_STANDARD_SETTINGS_SUCCESS
export const GET_STANDARD_SETTINGS_SUCCESS = '[User Settings] GET_STANDARD_SETTINGS_SUCCESS'

export type GET_STANDARD_SETTING = typeof GET_STANDARD_SETTING
export const GET_STANDARD_SETTING = '[User Settings] GET_STANDARD_SETTING'

export const GET_STANDARD_SETTING_SUCCESS = '[User Settings] GET_STANDARD_SETTING_SUCCESS'
export type GET_STANDARD_SETTING_SUCCESS = typeof GET_STANDARD_SETTING_SUCCESS

export type CREATE_STANDARD_SETTING = typeof CREATE_STANDARD_SETTING
export const CREATE_STANDARD_SETTING = '[User Settings] CREATE_STANDARD_SETTING'

export const CREATE_STANDARD_SETTING_SUCCESS = '[User Settings] CREATE_STANDARD_SETTING_SUCCESS'
export type CREATE_STANDARD_SETTING_SUCCESS = typeof CREATE_STANDARD_SETTING_SUCCESS

export type UPDATE_STANDARD_SETTING = typeof UPDATE_STANDARD_SETTING
export const UPDATE_STANDARD_SETTING = '[User Settings] UPDATE_STANDARD_SETTING'

export const UPDATE_STANDARD_SETTING_SUCCESS = '[User Settings] UPDATE_STANDARD_SETTING_SUCCESS'
export type UPDATE_STANDARD_SETTING_SUCCESS = typeof UPDATE_STANDARD_SETTING_SUCCESS

/* Roles */
export type GET_ROLES = typeof GET_ROLES
export const GET_ROLES = '[User Settings] GET_ROLES'

export const GET_ROLES_SUCCESS = '[User Settings] GET_ROLES_SUCCESS'
export type GET_ROLES_SUCCESS = typeof GET_ROLES_SUCCESS

export type GET_PAGINATED_ROLES = typeof GET_PAGINATED_ROLES
export const GET_PAGINATED_ROLES = '[User Settings] GET_PAGINATED_ROLES'

export const GET_PAGINATED_ROLES_SUCCESS = '[User Settings] GET_PAGINATED_ROLES_SUCCESS'
export type GET_PAGINATED_ROLES_SUCCESS = typeof GET_PAGINATED_ROLES_SUCCESS

export const SORT_ROLES = '[User Settings] SORT_ROLES'
export type SORT_ROLES = typeof SORT_ROLES

export type GET_ROLE = typeof GET_ROLE
export const GET_ROLE = '[User Settings] GET_ROLE'

export type GET_ROLE_SUCCESS = typeof GET_ROLE_SUCCESS
export const GET_ROLE_SUCCESS = '[User Settings] GET_ROLE_SUCCESS'

export type DELETE_ROLE = typeof DELETE_ROLE
export const DELETE_ROLE = '[User Settings] DELETE_ROLE'

export type DELETE_ROLE_SUCCESS = typeof DELETE_ROLE_SUCCESS
export const DELETE_ROLE_SUCCESS = '[User Settings] DELETE_ROLE_SUCCESS'

export type CREATE_ROLE = typeof CREATE_ROLE
export const CREATE_ROLE = '[User Settings] CREATE_ROLE'

export type CREATE_ROLE_SUCCESS = typeof CREATE_ROLE_SUCCESS
export const CREATE_ROLE_SUCCESS = '[User Settings] CREATE_ROLE_SUCCESS'

export type UPDATE_ROLE = typeof UPDATE_ROLE
export const UPDATE_ROLE = '[User Settings] UPDATE_ROLE'

export type UPDATE_ROLE_SUCCESS = typeof UPDATE_ROLE_SUCCESS
export const UPDATE_ROLE_SUCCESS = '[User Settings] UPDATE_ROLE_SUCCESS'

export type ROLES_HAS_ERRORED = typeof ROLES_HAS_ERRORED
export const ROLES_HAS_ERRORED = '[User Settings] ROLES_HAS_ERRORED'

export type OPEN_ROLE_FORM = typeof OPEN_ROLE_FORM
export const OPEN_ROLE_FORM = '[User Settings] OPEN_ROLE_FORM'

export type SELECT_ROLE = typeof SELECT_ROLE
export const SELECT_ROLE = '[User Settings] SELECT_ROLE'

export type SET_ROLE_ACTIVE_PAGE = typeof SET_ROLE_ACTIVE_PAGE
export const SET_ROLE_ACTIVE_PAGE = '[User Settings] SET_ROLE_ACTIVE_PAGE'

export const FILTER_ROLES = '[User Settings] FILTER_ROLES'
export type FILTER_ROLES = typeof FILTER_ROLES

export type GET_RIGHTS = typeof GET_RIGHTS
export const GET_RIGHTS = '[User Settings] GET_RIGHTS'

export const GET_RIGHTS_SUCCESS = '[User Settings] GET_RIGHTS_SUCCESS'
export type GET_RIGHTS_SUCCESS = typeof GET_RIGHTS_SUCCESS

// Position Billing Rate
export type SELECT_POSITION = typeof SELECT_POSITION
export const SELECT_POSITION = '[User Settings] SELECT_POSITION'

export type UPDATE_POSITION_BILLING_RATE = typeof UPDATE_POSITION_BILLING_RATE
export const UPDATE_POSITION_BILLING_RATE = '[User Settings] UPDATE_POSITION_BILLING_RATE'

export type UPDATE_POSITION_BILLING_RATE_SUCCESS = typeof UPDATE_POSITION_BILLING_RATE_SUCCESS
export const UPDATE_POSITION_BILLING_RATE_SUCCESS = '[User Settings] UPDATE_POSITION_BILLING_RATE_SUCCESS'

export type CREATE_POSITION_BILLING_RATE = typeof CREATE_POSITION_BILLING_RATE
export const CREATE_POSITION_BILLING_RATE = '[User Settings] CREATE_POSITION_BILLING_RATE'

export type CREATE_POSITION_BILLING_RATE_SUCCESS = typeof CREATE_POSITION_BILLING_RATE_SUCCESS
export const CREATE_POSITION_BILLING_RATE_SUCCESS = '[User Settings] CREATE_POSITION_BILLING_RATE_SUCCESS'

export type REMOVE_POSITION_BILLING_RATE = typeof REMOVE_POSITION_BILLING_RATE
export const REMOVE_POSITION_BILLING_RATE = '[User Settings] REMOVE_POSITION_BILLING_RATE'

export type REMOVE_POSITION_BILLING_RATE_SUCCESS = typeof REMOVE_POSITION_BILLING_RATE_SUCCESS
export const REMOVE_POSITION_BILLING_RATE_SUCCESS = '[User Settings] REMOVE_POSITION_BILLING_RATE_SUCCESS'
